(() => {
  if (window.Shopify && window.Shopify.designMode) return;

  const OPEN_KEY = 'oval_open_cart_on_home';

  function isCartPath() {
    return /^\/cart\/?$/.test(window.location.pathname);
  }

  function goHomeAndOpenCart() {
    sessionStorage.setItem(OPEN_KEY, '1');
    window.location.replace('/');
  }

  function openCartUI() {
    const drawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('[data-cart-drawer]') ||
      document.querySelector('#CartDrawer');

    if (drawer) {
      if (typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      if (typeof drawer.show === 'function') {
        drawer.show();
        return true;
      }
    }

    const cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
      cartIcon.click();
      return true;
    }

    return false;
  }

  window.addEventListener('DOMContentLoaded', () => {
    if (isCartPath()) {
      goHomeAndOpenCart();
      return;
    }

    const shouldOpen = sessionStorage.getItem(OPEN_KEY) === '1';
    if (!shouldOpen) return;

    sessionStorage.removeItem(OPEN_KEY);

    setTimeout(() => {
      openCartUI();
    }, 50);
  });
})();